// 获取url param
export const getUrlQuery = () => {
    if(!window.location.href) return {}
    const query = window.location.href.split('?')
    if(query.length <= 1) return {}
    let str = query[1]
    const arr = str.split('&')
    const obj = {}
    arr.map(h => {
        let subArr = h.split('=')
        obj[subArr[0]] = subArr[1]
    })
    return obj
}

